export var valuesVisualizationType = ["Diagram", "NumberWithChange"];
/*

*/ 
//# sourceMappingURL=VisualizationType.js.map